import React, { useState, useEffect, useContext } from "react";
import { Context } from "context/AuthContext";

import CategoryList from "components/CategoryList";
import {
  GET_CATEGORIA_ARVORE,
  SAVE_CATEGORIA,
  DELETE_CATEGORIA,
} from "services/Categoria";

import "./styles.scss";
import { useAlert } from "context/AlertContext";

const ContentAdminQuestao = () => {
  const { showLoader } = useContext(Context);
  const { showAlert } = useAlert();

  const [categorias, setCategorias] = useState([]);

  const addCategoriaTemp = (categoria) => {
    const tempCategoria = {
      id: 0,
      nome: "",
      parentId: categoria.id,
      tipoId: categoria.TipoFilhoId,
      tipoNome: categoria.TipoFilho,
      linkVideoAula: "",
      children: [],
    };
    const updateItems = (categorias) => {
      return categorias.map((item) => {
        if (item.id === categoria.id) {
          return { ...item, children: [tempCategoria, ...item.children] };
        } else if (item.children.length > 0) {
          return { ...item, children: updateItems(item.children) };
        }
        return item;
      });
    };
    const teste = updateItems(categorias);
    setCategorias(teste);
  };

  const updateItemName = async (categoria, newName, videoLink) => {
    showLoader(true);
    const tempCategoria = {
      CategoriaId: categoria.id,
      CategoriaTipoId: categoria.tipoId,
      CategoriaSuperiorId: categoria.parentId,
      nome: newName,
      linkVideoAula: videoLink,
    };
    const data = await SAVE_CATEGORIA(tempCategoria);
    if (data.errors !== null) {
      showAlert(data.errors, "danger");
      showLoader(false);
      return null;
    }
    if (data.value === null) {
      showAlert("Erro ao atualizar categoria", "danger");
      showLoader(false);
      return null;
    }
    const updateItems = (categorias) => {
      return categorias.map((item) => {
        if (item.id === categoria.id) {
          return {
            ...item,
            id: data.value.categoriaId,
            nome: data.value.nome,
            parentId: data.value.categoriaSuperiorId,
            tipoId: data.value.categoriaTipoId,
            tipoNome: data.value.categoriaTipo.nome,
            TipoFilhoId: data.value.categoriaTipo.categoriaTipoFilhoId,
            linkVideoAula: data.value.linkVideoAula,
          };
        }
        if (item.children && item.children.length > 0) {
          return { ...item, children: updateItems(item.children) };
        }
        return item;
      });
    };

    setCategorias(updateItems(categorias));

    showLoader(false);

    showAlert(
      `Categoria ${
        categoria.id === 0 ? "adicionada" : "atualizada"
      } com sucessso.`,
      "success"
    );

    return data.value;
  };
  const deleteItem = async (categoria) => {
    showLoader(true);

    const data = await DELETE_CATEGORIA(categoria.id);
    if (data.errors !== null) {
      showAlert(data.errors, "danger");
      showLoader(false);
      return null;
    }
    if (data.value === null || data.value === false) {
      showAlert("Erro ao deletar categoria", "danger");
      showLoader(false);
      return null;
    }
    if (data.value === true) {
      showAlert("Categoria deletada com sucesso", "success");
    }

    const removeItem = (categorias) => {
      return categorias.filter((item) => {
        if (item.id === categoria.id) {
          return false; // remove o item da lista
        }
        if (item.children.length > 0) {
          item.children = removeItem(item.children); // recursivamente remove dos filhos
        }
        return true;
      });
    };

    const updatedCategorias = removeItem(categorias);
    setCategorias(updatedCategorias);
    showLoader(false);

    return data.value;
  };

  const removerTemporario = (categoriaId) => {
    const removeTemp = (categorias) => {
      return categorias.map((item) => {
        if (item.id === categoriaId) {
          return {
            ...item,
            children: item.children.filter((child) => child.id !== 0),
          };
        }
        if (item.children.length > 0) {
          return { ...item, children: removeTemp(item.children) };
        }
        return item;
      });
    };

    setCategorias(removeTemp(categorias));
  };

  useEffect(() => {
    (async () => {
      showLoader(true);

      const data = await GET_CATEGORIA_ARVORE();
      if (data.errors !== null) {
        showAlert(data.errors, "danger");
        showLoader(false);
        return;
      }
      if (data.value === null) {
        showAlert("Erro ao buscar categorias", "danger");
        showLoader(false);
        return;
      }
      setCategorias(data.value);
      showLoader(false);
    })();
    // eslint-disable-next-line
  }, []);

  const addCategoriaRaizTemp = () => {
    const tempCategoria = {
      id: 0,
      nome: "",
      parentId: null,
      tipoId: 1,
      tipoNome: "",
      TipoFilhoId: null,
      children: [],
    };
    setCategorias([tempCategoria, ...categorias]);
  };
  const removeCategoriaRaizTemp = () => {
    setCategorias(categorias.filter((categoria) => categoria.id !== 0));
  };
  return (
    <div className="category-wrapper">
      <h1 className="content-header">Categorias</h1>
      <hr />
      <div className="category-content">
        <CategoryList
          items={categorias}
          setCategorias={setCategorias}
          updateItemName={updateItemName}
          addCategoriaTemp={addCategoriaTemp}
          deleteItem={deleteItem}
          removerTemporario={removerTemporario}
          addCategoriaRaizTemp={addCategoriaRaizTemp}
          removeCategoriaRaizTemp={removeCategoriaRaizTemp}
        />
      </div>
    </div>
  );
};

export default ContentAdminQuestao;
